import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosing2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 40,
			x2: 40,
			y2: 12,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 73,
			y1: 40,
			x2: 80,
			y2: 40,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: 40,
			x2: 12,
			y2: 40,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 68.28,
			y1: 11.72,
			x2: 59.8,
			y2: 20.2,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 11.72,
			y1: 11.72,
			x2: 20.2,
			y2: 20.2,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.66,48a20,20,0,1,1,36.68,0",
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: 48,
			x2: 80,
			y2: 48,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 10,
			y1: 58,
			x2: 70,
			y2: 58,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 20,
			y1: 68,
			x2: 60,
			y2: 68,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 30,
			y1: 78,
			x2: 50,
			y2: 78,
			fill: "none",
			stroke: "currentcolor",
			strokeMiterlimit: 10,
			strokeWidth: 4
		})
	]
});
export default SvgClosing2;
